

























import PieceMixin from "@/app/basic/common/mixin/PieceMixin.vue";
import { Component } from "vue-property-decorator";

@Component
export default class MapMaskPieceComponent extends PieceMixin<"map-mask"> {}
